// extracted by mini-css-extract-plugin
module.exports = {"open":"styles_open__QjJsH","close":"styles_close__ev8k6","arrow_size_medium":"styles_arrow_size_medium__6S2U9","arrow_size_smallsvg":"styles_arrow_size_smallsvg__pHaD4"};